import React, { useEffect, useState } from "react";
import { showToast } from "services/utils/Status";
import * as Mui from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";
import { KeyboardArrowDown, ChevronRight } from "@mui/icons-material";
import { themes, optionalAvathar } from "services/constants";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { tableRowSx } from "services/constants";

export const PunchDetails = ({
  punchDetailsData,
  startDate,
  endDate,
  departmentName,
  shiftCategoryName,
  setRemoveExpand,
  removeExpand,
  setPunchExports,
  punchExports,
  page,
  setLeavePage,
  setLeaveRowsPerPage,
  rowsPerPage,
  masterPunchDetails,
}) => {
  const [personExpandableUsername, setPersonExpandableUsername] = useState("");
  const { topbarCompanyName } = useSelector((state) => state.tokenReducer);

  useEffect(() => {
    if (removeExpand) {
      setPersonExpandableUsername("");
      setRemoveExpand(false);
    }
  }, [removeExpand, setRemoveExpand]);

  const handleChangePage = (event, newPage) => {
    setLeavePage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  useEffect(() => {
    const punchExportsDetails = () => {
      if (punchDetailsData.length !== 0) {
        let dataPreparation = [];
        punchDetailsData.forEach((element) => {
          element?.punches?.forEach((punchEntries) => {
            let overAllData = {
              date: punchEntries.date,
              username: element.username,
              employee_id: element.employee_id,
              shift_name: punchEntries.shift_name,
              device_name: punchEntries.device_name,
              direction: punchEntries.direction,
              punch_time: punchEntries.punch_time,
              attendance_time: punchEntries.attendance_time,
              location: punchEntries.location,
              modified_by: punchEntries.modified_by,
              manually_deleted: punchEntries.is_manual_delete ? "Yes" : "No",
            };
            dataPreparation = [...dataPreparation, overAllData];
          });
        });
        if (dataPreparation.length !== 0) {
          const companyName = ["Company Name"];
          const department = ["Department Name"];
          const shiftCategory = ["ShiftCategory Name"];
          const shift = ["Shift Name"];
          const date = ["Date"];
          const GeneratedOn = ["Report Generated On"];
          companyName.push(topbarCompanyName);
          department.push(departmentName);
          shiftCategory.push(shiftCategoryName);
          date.push(`${startDate} to ${endDate}`);
          GeneratedOn.push(moment(new Date()).format("DD/MM/YYYY, hh:mm a"));
          const items = dataPreparation;
          const TableHead = ["Date"];
          TableHead.push("Employee Name");
          TableHead.push("Employee Id");
          TableHead.push("ShiftName");
          TableHead.push("Device Name");
          TableHead.push("Direction");
          TableHead.push("PunchIn");
          TableHead.push("Attendance Time");
          TableHead.push("Location");
          TableHead.push("Modified by");
          TableHead.push("Is Manually Deleted");
          const replacer = (key, value) => (value === null ? "" : value);
          const header = Object?.keys(items[0]);
          let csv = items.map((row) =>
            header
              .map((fieldName) => JSON.stringify(row[fieldName], replacer))
              .join(",")
          );
          csv.unshift(TableHead.join(","));
          csv.unshift(GeneratedOn.join(","));
          csv.unshift(date.join(","));
          csv.unshift(shift.join(","));
          csv.unshift(shiftCategory.join(","));
          csv.unshift(department.join(","));
          csv.unshift(companyName.join(","));
          csv = csv.join("\r\n");
          const ConvertData = csv;
          const element = document.createElement("a");
          const file = new Blob([ConvertData], {
            type: "text/plain",
          });
          element.href = URL.createObjectURL(file);
          element.download = "Punch.csv";
          document.body.appendChild(element);
          element.click();
        } else {
          showToast("error", "No data available");
        }
      } else {
        showToast("error", "No data available");
      }
    };
    if (punchExports) {
      punchExportsDetails();
      setPunchExports(false);
    }
  }, [
    departmentName,
    endDate,
    punchDetailsData,
    punchExports,
    setPunchExports,
    shiftCategoryName,
    startDate,
    topbarCompanyName,
  ]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          sx={{ mt: 2, width: "100%", maxHeight: 660, ml: 2, mr: 2 }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Action
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Employee Name
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Employee Id
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Punch count
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {punchDetailsData?.length === 0 ? (
                <InfoMessage dataLength={masterPunchDetails} />
              ) : (
                punchDetailsData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((element) => (
                    <>
                      <Mui.TableRow sx={tableRowSx}>
                        <Mui.TableCell>
                          {element?.username === personExpandableUsername ? (
                            <Mui.IconButton
                              onClick={() => setPersonExpandableUsername("")}
                            >
                              <KeyboardArrowDown />
                            </Mui.IconButton>
                          ) : (
                            <Mui.IconButton
                              onClick={() =>
                                setPersonExpandableUsername(element?.username)
                              }
                              style={{
                                padding: "0px",
                              }}
                            >
                              <ChevronRight />
                            </Mui.IconButton>
                          )}
                        </Mui.TableCell>
                        <Mui.TableCell>
                          <Mui.Stack direction="Row">
                            <Mui.Avatar
                              sx={{ width: 23, height: 23 }}
                              alt="Remy Sharp"
                              src={element?.image_url ?? optionalAvathar}
                            />
                            <Mui.Typography
                              sx={{
                                paddingLeft: 1,
                              }}
                            >
                              {element.username}
                            </Mui.Typography>
                          </Mui.Stack>
                        </Mui.TableCell>
                        <Mui.TableCell>{element.employee_id}</Mui.TableCell>
                        <Mui.TableCell>{element.punch_in_count}</Mui.TableCell>
                      </Mui.TableRow>
                      {personExpandableUsername === element?.username && (
                        <Mui.TableRow sx={tableRowSx}>
                          <Mui.TableCell colSpan={12}>
                            <Mui.TableContainer
                              sx={{
                                marginTop: 0,
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "100%",
                              }}
                              className="w-96 border rounded"
                            >
                              {element?.punches?.length !== 0 ? (
                                <Mui.Table className="border">
                                  <Mui.TableHead
                                    sx={{
                                      backgroundColor: themes.primary,
                                    }}
                                  >
                                    <Mui.TableRow sx={tableRowSx}>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Date
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Shift
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Punch in
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Attendance Time
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Direction
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Device name
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Location
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Modified by
                                      </Mui.TableCell>
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                          textAlign: "left",
                                        }}
                                      >
                                        Is Manually Deleted
                                      </Mui.TableCell>
                                    </Mui.TableRow>
                                  </Mui.TableHead>
                                  <Mui.TableBody>
                                    {element?.punches?.map(
                                      (shiftDetails, index) => (
                                        <>
                                          <Mui.TableRow
                                            key={index}
                                            sx={tableRowSx}
                                          >
                                            <Mui.TableCell>
                                              {shiftDetails?.date}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails?.shift_name}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails?.punch_time}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails?.attendance_time}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails?.direction}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails?.device_name}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails?.location}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails.modified_by
                                                ? shiftDetails.modified_by
                                                : "-"}
                                            </Mui.TableCell>
                                            <Mui.TableCell>
                                              {shiftDetails.is_manual_delete
                                                ? "Yes"
                                                : "No"}
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        </>
                                      )
                                    )}
                                  </Mui.TableBody>
                                </Mui.Table>
                              ) : (
                                <Mui.Stack
                                  sx={{ padding: 0.5 }}
                                  spacing={2}
                                  fullWidthy
                                >
                                  <Mui.Alert severity="info">
                                    There is a no available shifts
                                  </Mui.Alert>
                                </Mui.Stack>
                              )}
                            </Mui.TableContainer>
                          </Mui.TableCell>
                        </Mui.TableRow>
                      )}
                    </>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
        <Mui.Grid
          container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          {punchDetailsData.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={punchDetailsData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Mui.Grid>
      </Mui.Grid>
    </React.Fragment>
  );
};
